import { render, staticRenderFns } from "./GlobbingConfigsLong.vue?vue&type=template&id=4d519030&scoped=true"
import script from "./GlobbingConfigsLong.vue?vue&type=script&lang=js"
export * from "./GlobbingConfigsLong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d519030",
  null
  
)

export default component.exports